import React, { useMemo } from 'react';
import JobList from '../../../features/jobs/components/JobList';
import useAppliedJobs from '../../../features/jobs/hooks/useAppliedJobs';
import CardIcon from '../../../shared/components/icons/CardIcon';

function Applications() {
  const { jobs, loading, error, setJobs } = useAppliedJobs();
  const visibleJobs = useMemo(() => {
    const statusOrder = { hired: 0, pending: 1, rejected: 2 };

    return jobs
      .filter((job) => (job.applicationStatus || job.status || '').toLowerCase() !== 'completed')
      .sort((firstJob, secondJob) => {
        const firstOrder = statusOrder[(firstJob.applicationStatus || firstJob.status || 'pending').toLowerCase()] ?? 1;
        const secondOrder = statusOrder[(secondJob.applicationStatus || secondJob.status || 'pending').toLowerCase()] ?? 1;
        return firstOrder - secondOrder;
      });
  }, [jobs]);

  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-white p-6 sm:p-8 shadow-sm">
        <h1 className="flex items-center gap-3 text-2xl sm:text-3xl font-bold tracking-tight text-navy"><CardIcon name="application" className="h-7 w-7" />Applied jobs</h1>
        <p className="mt-2 text-sm text-slate-600">Track the status of your applications and contact employers once you are hired.</p>
      </div>

      <JobList jobs={visibleJobs} loading={loading} error={error} showActions={false} applicationView onCancel={(applicationId) => setJobs((current) => current.filter((job) => job.applicationId !== applicationId))} />
    </div>
  );
}

export default Applications;

